import React, { useEffect, useId, useState } from "react";
import { Container, Stack } from "react-bootstrap";
import { getConsignmentAnimalCount, getDailyMortalitiesCountForConsignmentID } from "../../api/apiAccess";
import { formatUpToSpecifiedPrecision } from "../../utils/common";

const MortalitiesOverview = ({ consignment, index, isStarted }) => {
    const componentId = useId();
    const [mortalities, setMortalities] = useState("");
    const [consignmentAnimalCount, setConsignmentAnimalCount] = useState(-1);
    const [mortalitiesLatestReport, setMortalitiesLatestReport] = useState("-");
    const [mortalitiesTotal, setMortalitiesTotal] = useState("-");
    const [mortalitiesTotalPercentage, setMortalitiesTotalPercentage] = useState("");

    useEffect(() => {
        if (consignment === undefined || isStarted === false) return;

        const fetchMortalities = async () => {
            let results = await getDailyMortalitiesCountForConsignmentID(consignment.id);
            if (results?.status === 200) {
                setMortalities(results.data);
            }
        }

        const fetchConsignmentAnimalCount = async () => {
            let results = await getConsignmentAnimalCount(consignment.id);
            if (results?.status === 200) {
                setConsignmentAnimalCount(results.data);
            }
        }

        const fetchAll = () => {
            fetchMortalities();
            fetchConsignmentAnimalCount();
        }

        fetchAll();

    }, [consignment, isStarted]);

    useEffect(() => {
        if (!isStarted) return;
        if (mortalities === "") return;
        calculateMortalitiesData();
    }, [mortalities, consignmentAnimalCount]);

    const calculateMortalitiesData = () => {
        const totalMortalities = (mortalities ?? []).reduce(
            (sum, t) => sum + (t.numberOfMortalities ?? 0),
            0
        );
        setMortalitiesTotal(totalMortalities);

        const latestDayMortalitiesCount = (mortalities ?? []).reduce(
            (latest, t) =>
                t && (!latest || t.dayNumber > latest.dayNumber) ? t : latest,
            null
        )?.numberOfMortalities ?? 0;
        setMortalitiesLatestReport(latestDayMortalitiesCount);
        
        if (consignmentAnimalCount !== -1 && consignmentAnimalCount >= mortalities.length && mortalities.length > 0) {
            let mortalityPercentage = (totalMortalities / consignmentAnimalCount * 100);
            // round/format
            let lFormatted = formatUpToSpecifiedPrecision(mortalityPercentage, 2);
            setMortalitiesTotalPercentage(lFormatted);
        }
    }

    return (
        <Container fluid key={`mortalities_overview_${componentId}_${index}`} className="my-auto mx-0 px-auto">
            <Stack direction="vertical">
                <Stack direction="horizontal">
                    <Stack className="text-center" direction="vertical">
                        <div>{mortalitiesLatestReport}</div>
                        <div className="field-label">Latest Report</div>
                    </Stack>
                    {isStarted ?
                        (
                            <Stack className="text-center" direction="vertical">
                                <div>{mortalitiesTotal}</div>
                                <div className="field-label">Voyage</div>
                                {
                                    mortalitiesTotal > 0 && consignmentAnimalCount !== -1 ? (
                                        <div className="field-label" style={{ fontSize: "11px" }}>{mortalitiesTotalPercentage}%</div>
                                    ) : null
                                }
                            </Stack>
                        ) : null
                    }
                </Stack>
            </Stack>
        </Container>
    )
};

export default MortalitiesOverview;